<template>
  <!-- wrapper(s) -->
  <div class="wrapper">
    <Header class="header" data-title="회원가입" :type="'empty'"></Header>
    <div class="container">
      <!-- content(s) -->
      <div id="content">
        <div class="progress">
          <ol>
            <li><span>약관동의</span></li>
            <li class="on"><span>정보 입력</span></li>
            <li><span>정보입력(선택)</span></li>
          </ol>
        </div>

        <section class="hr">
          <div class="titArea">
            <h2 class="titH3 normal">회원 정보 입력</h2>
            <p class="giftTime">
              <span class="blind">타임미션 제한시간</span>
              <span class="timer" :class="{ pointC1: time > 300 }">{{ time | convertTimeToMS }}</span>
            </p>
          </div>

          <ValidationObserver ref="form">
            <div class="formArea">
              <span class="label">
                아이디
                <span class="required"><span class="blind">필수</span></span>
              </span>
              <ValidationProvider name="아이디" rules="required|userId" v-slot="{ errors }" vid="userId">
                <input
                  type="text"
                  autocapitalize="off"
                  autocomplete="off"
                  id="ipt1_1"
                  class="ipt"
                  placeholder="영문 또는 영문, 숫자 포함 4~12자리"
                  title="아이디 입력(영문, 숫자 포함 4~12자리(이메일도 가능))"
                  maxlength="12"
                  v-model="userId"
                />
                <p class="fieldMsg error" id="idMsg" v-if="errors[0]">
                  {{ errors[0] }}
                </p>
              </ValidationProvider>

              <span class="label">
                비밀번호
                <span class="required"><span class="blind">필수</span></span>
              </span>
              <ValidationProvider name="비밀번호" rules="required|password" v-slot="{ errors }" vid="password">
                <input
                  type="password"
                  id="ipt2"
                  class="ipt"
                  placeholder="영문 대/소문자, 숫자, 특수문자 포함 8자리 이상"
                  title="비밀번호 입력(영문 대/소문자, 숫자, 특수문자 포함 8자리 이상)"
                  value=""
                  v-model="password"
                />

                <p class="fieldMsg error" id="idMsg" v-if="errors[0]" style="white-space:pre">{{ errors[0] }}</p>
              </ValidationProvider>

              <span class="label">
                비밀번호 확인
                <span class="required"><span class="blind">필수</span></span>
              </span>
              <ValidationProvider name="비밀번호 확인" rules="required|confirmed:password" v-slot="{ errors }" vid="passwordChk">
                <input
                  type="password"
                  id="ipt3"
                  class="ipt"
                  placeholder="동일한 비밀번호를 입력해주세요"
                  title="비밀번호 확인 입력(동일한 비밀번호를 입력해주세요)"
                  value=""
                  v-model="passwordChk"
                />
                <p class="fieldMsg error" id="idMsg" v-if="errors[0]">
                  {{ errors[0] }}
                </p>
              </ValidationProvider>

              <span class="label">
                이름
                <span class="required"><span class="blind">필수</span></span>
              </span>
              <ValidationProvider name="이름" rules="required" v-slot="{ errors }" vid="userName">
                <input type="text" id="ipt4" class="ipt" title="이름 입력" autocomplete="off" value="" v-model="userName" />
                <p class="fieldMsg error" id="idMsg" v-if="errors[0]">
                  {{ errors[0] }}
                </p>
              </ValidationProvider>

              <span class="label">
                생년월일
                <span class="required"><span class="blind">필수</span></span>
              </span>

              <div class="setBirth">
                <input
                  type="tel"
                  class="ipt"
                  autocomplete="off"
                  maxlength="4"
                  title="생년월일 년도 4자리"
                  placeholder="1990"
                  name="year"
                  v-model="year"
                  @blur="birthValidate"
                  v-skipOfMax
                  nextTarget="mm"
                  id="yyyy"
                />
                <span class="sign" aria-hidden="true">/</span>
                <input
                  type="tel"
                  class="ipt"
                  autocomplete="off"
                  maxlength="2"
                  title="생년월일 월 2자리"
                  placeholder="01"
                  value="2"
                  name="month"
                  v-model="month"
                  @blur="birthValidate"
                  v-skipOfMax
                  nextTarget="dd"
                  id="mm"
                />
                <span class="sign" aria-hidden="true">/</span>
                <input
                  type="tel"
                  class="ipt"
                  autocomplete="off"
                  maxlength="2"
                  title="생년월일 일 2자리"
                  placeholder="01"
                  value="3"
                  name="day"
                  v-model="day"
                  @blur="birthValidate"
                  id="dd"
                />
              </div>

              <ValidationProvider name="생년월일" rules="required|birth|lastDay" v-slot="{ errors }" vid="birth" ref="birth">
                <input type="hidden" id="birth" class="ipt" v-model="birth" />
                <p class="fieldMsg error" id="idMsg" v-if="errors[0]">
                  {{ errors[0] }}
                </p>
              </ValidationProvider>

              <span class="label">
                휴대폰번호
                <span class="required"><span class="blind">필수</span></span>
              </span>

              <ValidationProvider name="휴대폰번호" rules="required|cellNum" v-slot="{ errors }" id="cellNum" ref="cellNum">
                <!--
                <div class="setPhone">
                  <input
                    type="tel"
                    id="phone_2"
                    class="ipt"
                    autocomplete="off"
                    title="휴대폰 번호 입력"
                    placeholder="' - ' 없이 입력해주세요."
                    value=""
                    v-model="cellNum"
                  />
                  <button type="button" class="btn_s round s" @click="sendAuthNumber">
                    {{ authButtonTitle }}
                  </button>
                </div>
                -->

                <div class="setAddr uiAct">
                  <div class="iptWrap">
                    <input
                      type="tel"
                      id="phone_2"
                      class="ipt notDel uiAct"
                      title="휴대폰 번호 입력"
                      placeholder="' - ' 없이 입력해주세요."
                      value=""
                      v-model="cellNum"
                      v-onlyNum
                    />
                  </div>
                  <button type="button" class="btn_g m" @click="sendAuthNumber">{{ authButtonTitle }}</button>
                </div>
                <p class="fieldMsg error" id="idMsg" v-if="errors[0]">
                  {{ errors[0] }}
                </p>
              </ValidationProvider>

              <!--
              <div v-show="authButtonShow">
                <ValidationProvider name="인증번호" rules="required|max:4" v-slot="{ errors }" vid="authKey">
                  <input
                    type="number"
                    id="phone_3"
                    class="ipt addTxt"
                    autocomplete="off"
                    title="인증번호 입력"
                    placeholder=""
                    value=""
                    v-model="authKey"
                  />
                  <span class="txt">
                    유효시간
                    <strong class="pointC1">{{ authTime | convertTimeToMS }}</strong>
                  </span>
                  <p class="fieldMsg error" id="idMsg"  v-if="errors[0]">
                    {{ errors[0] }}
                  </p>
                </ValidationProvider>
              </div>
              -->

              <div class="uiAct" v-show="authButtonShow">
                <div class="iptWrap addTxt">
                  <input
                    type="tel"
                    id="phone_3"
                    class="ipt notDel uiAct"
                    title="휴대폰 번호 입력"
                    placeholder=""
                    value=""
                    v-model="authKey"
                    v-onlyNum
                  />
                  <span class="txt">
                    <strong class="pointC1">{{ authTime | convertTimeToMS }}</strong>
                  </span>
                </div>
              </div>
            </div>
          </ValidationObserver>

          <div class="btnArea sticky">
            <button type="button" class="btn_p" @click="join" :disabled="regButtonShow">다음</button>
          </div>
        </section>
      </div>
      <!-- content(e) -->
    </div>
    <!-- container(e) -->
    <footer class="footer"></footer>

    <MessagePop v-if="messagePop" @close="close">
      <p v-html="msg"></p>
    </MessagePop>
  </div>
  <!-- wrapper(e) -->
</template>
<script>
import ApiService from '@/common/api.service';
import MessagePop from '@/components/popup/MessagePop';
import { INPUT_INFO_CHECK, AUTH_TIMEOUT, JOIN_AGE_CHECK, JOIN_CONFIRM } from '@/store/message.type';
import { SET_JOIN_INFO } from '@/store/mutations.type';
import { isEmpty, calcAge } from '@/common/common.function';

export default {
  name: 'JoinStep3',
  components: { MessagePop },
  mounted() {
    // 시간미션 이벤트
    this.time = window.localStorage.getItem('time');
    this.timeEvent = setInterval(() => {
      /*if (this.countUp)*/ this.time++;
      //else this.time--;
    }, 1000);
    // 입력한 회원가입정보가 있으면 화면에 다시 세팅
    this.joinInfo = this.$store.getters.joinInfo;
    if (!isEmpty(this.joinInfo)) {
      this.userId = this.joinInfo.userId;
      this.password = this.joinInfo.password;
      this.passwordChk = this.joinInfo.password;
      this.userName = this.joinInfo.userName;
      this.year = this.joinInfo.birth.substring(0, 4);
      this.month = this.joinInfo.birth.substring(4, 6);
      this.day = this.joinInfo.birth.substring(6, 8);
      this.cellNum = this.joinInfo.cellNum;
    }
  },
  data() {
    return {
      time: null, // 회원가입 이벤트용 시간
      timeColor: null, // 회원가입 이벤트용 문구 색상

      userId: null, // 아이디
      password: null, // 비밀번호
      passwordChk: null, // 비밀번호 확인
      userName: null, // 이름
      year: null, // 년
      month: null, // 월
      day: null, // 일
      cellNum: null, //휴대폰번호

      authKey: null, // 인증번호 입력란
      // authTime: 180, // 인증시간(초)
      authTime: 180, // 초기 세팅 시간 테스트로 10초로 설정 원래는 180초
      authButtonTitle: '인증번호요청', // 인증번호 버튼명 ( 인증번호요청 / 재요청 )
      authButtonShow: false,

      msg: null, // 팝업 msg
      messagePop: false,
      joinInfo: {}, // 회원가입 정보 저장용 Object

      regButtonShow: true,
    };
  },
  watch: {
    // 시간미션 이벤트
    time() {
      /*if (this.time == 0) {
          this.time = 300;
          this.countUp = true;
        }*/
      if (this.time > 300) {
        this.countUp = true;
      }
    },
    // 인증번호 시간 초과시
    authTime() {
      if (this.authTime == 0) {
        this.authButtonTitle = '인증번호요청'; // 버튼 타이틀 초기값으로 변경
        clearInterval(this.countDown); // 카운트다운 초기화
        this.errorCode = null; // API 통해 리턴 받은 에러 코드 값 초기화
        this.authKey = null; // 인증번호 입력란 초기화
        // this.authTime = 180;
        this.authTime = 180; // 인증번호 시간 초기화
        this.msg = AUTH_TIMEOUT; // API 서버에서도 리턴해주지만 클라이언트 쪽에서 처리하기 위해 메세지 추가
        this.messagePop = true;
      }
    },
    // 아이디 대문자 -> 소문자 변환
    userId() {
      this.userId = this.userId.toLowerCase();

      this.checkInput();
    },
    password() {
      this.checkInput();
    },
    passwordChk() {
      this.checkInput();
    },
    userName() {
      this.checkInput();
    },
    year() {
      this.checkInput();
    },
    month() {
      this.checkInput();
    },
    day() {
      this.checkInput();
    },
    cellNum() {
      this.checkInput();
    },
    authKey() {
      this.checkInput();
    },
  },
  computed: {
    // 생년월일 자동 처리
    birth() {
      return this.year + this.month + this.day;
    },
  },
  methods: {
    // 인증번호 호출
    sendAuthNumber() {
      this.$refs.cellNum.validate().then(success => {
        if (!success.valid || isEmpty(this.userId)) {
          this.msg = INPUT_INFO_CHECK;
          this.messagePop = true;
        } else {
          ApiService.service('POST', 'common/sms/auth', {
            request: {
              cellNum: this.cellNum,
              sendType: 'SPSM0001',
              userId: this.userId,
            },
            serviceType: 'app',
          })
            .then(({ data }) => {
              // TODO 인증번호 SMS 에서 INPUT BOX로 자동기입 방법 확인 필요
              console.log(data);
              console.log(data.result.authKey);
              console.log(data.result.transactionId);

              //인증번호 요청후 버튼 show
              this.authButtonShow = true;

              // TODO 모바일 테스트
              // this.authKey = data.result.authKey;
              this.tranId = data.result.transactionId;
              this.authButtonTitle = '재요청';

              clearInterval(this.countDown);
              this.authTime = 180;
              this.countDown = setInterval(() => {
                this.authTime--;
              }, 1000);
            })
            .catch(({ response }) => {
              console.log(response);
            });
        }
      });
    },
    join() {
      this.$refs.form.validate().then(async success => {
        if (!success) {
          this.msg = INPUT_INFO_CHECK;
          this.messagePop = true;
        } else {
          this.link = false; // 기간계에 연동할 데이터 체크 flag
          this.progress = true; // 진행여부

          // 1. 만 14세 미만 체크
          if (calcAge(this.birth.toString()) < 14) {
            this.msg = JOIN_AGE_CHECK;
            this.messagePop = true;
            return;
          }

          // 인증번호 일치여부 체크
          await ApiService.service('POST', 'common/sms/auth/check', {
            request: {
              authKey: this.authKey,
              birth: this.birth.substring(2),
              cellNum: this.cellNum,
              smsType: 'SPSM0001',
              tranId: this.tranId,
              userId: this.userId,
              userName: this.userName,
            },
            serviceType: 'app',
          })
            .then(({ data }) => {
              console.log(data);
              if (!data.isSucceed) {
                this.progress = false;
                this.msg = data.error;
                this.errorCode = data.errorCode;
                this.messagePop = true;
              }
            })
            .catch(({ response }) => {
              console.log('error : ' + response);
            });

          if (!this.progress) return;

          // 1. 기존 가입자 유무확인 2. 아이디 중복체크  3. 아이디, 비밀번호 validate 검증
          await ApiService.service('POST', 'user/validation', {
            request: {
              birth: this.birth.substring(2),
              cellNum: this.cellNum,
              password: this.password,
              sex: '',
              userId: this.userId,
              userName: this.userName,
            },
            serviceType: 'app',
          })
            .then(({ data }) => {
              console.log(data);
              if (!data.isSucceed) {
                this.progress = false;
                this.msg = data.error;
                this.errorCode = data.errorCode;
                this.messagePop = true;
              }
            })
            .catch(({ response }) => {
              console.log('error : ' + response);
            });

          if (!this.progress) return;
          // 가입 정보 Object 생성후 vuex로 저장
          this.joinInfo = {
            userId: this.userId,
            password: this.password,
            userName: this.userName,
            birth: this.birth,
            cellNum: this.cellNum,
            tranId: this.tranId,
          };

          this.$store.commit(SET_JOIN_INFO, this.joinInfo);

          // 렌탈 이력 확인
          await ApiService.service('POST', 'user/link', {
            request: {
              birth: this.birth.substring(2),
              cellNum: this.cellNum,
              password: this.password,
              sex: '',
              userId: this.userId,
              userName: this.userName,
            },
            serviceType: 'app',
          })
            .then(({ data }) => {
              console.log(data);
              if (data.result) {
                this.msg = JOIN_CONFIRM;
                this.link = true;
                this.messagePop = true;
              } else {
                this.$router.push('joinStep4');
              }
            })
            .catch(({ response }) => {
              console.log('error : ' + response);
            });
        }
      });
    },
    birthValidate() {
      this.$refs.birth.validate();
    },
    close() {
      this.messagePop = false;
      if (this.link) this.$router.push('joinStep4');
      if (this.errorCode == '-10026') {
        this.$router.push('/login');
      }
    },
    checkInput() {
      if (
        !isEmpty(this.userId) &&
        !isEmpty(this.password) &&
        !isEmpty(this.passwordChk) &&
        !isEmpty(this.userName) &&
        !isEmpty(this.year) &&
        !isEmpty(this.month) &&
        !isEmpty(this.day) &&
        !isEmpty(this.cellNum) &&
        !isEmpty(this.authKey)
      ) {
        this.regButtonShow = false;
      } else {
        this.regButtonShow = true;
      }
    },
  },
  // 페이지 이탈시 시간미션 시간 저장
  beforeDestroy() {
    window.localStorage.setItem('time', this.time);
  },
};
</script>
